import React from 'react';
import { InfoModal } from 'components/Modal';
import { Icon, Icons } from 'components/Icon';
import { Loader } from 'components/Loader';
import { useViewGeneratedPDF } from 'common/queries-and-mutations/admin/customer';

type IProps = {
  onCancel: () => void;
  userId: number;
  willId: number;
};

export default function WillPreviewModal({ onCancel, userId, willId }: IProps) {
  const { data, isLoading } = useViewGeneratedPDF(userId, willId);

  return (
    <InfoModal width="w-[60%]" className="h-fit rounded-md p-5">
      <div className="border-b-2 border-[#EBEBEB]">
        <div className="bottom-1 flex items-center justify-end">
          <button type="button" onClick={onCancel}>
            <Icon name={Icons.Close} />
          </button>
        </div>
      </div>
      {isLoading ? (
        <div className="my-20 flex flex-col items-center justify-center">
          <Loader type="Wait" color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          <div className="mt-5 flex flex-col items-center justify-center   pb-10 text-center">
            {/* <embed
              className="h-[500px] w-[800px] rounded bg-[#F4F4F4]"
              src={`data:application/pdf;base64,${data}`}
            /> */}
            <iframe
              className="h-[500px] w-[700px] rounded bg-[#F4F4F4]"
              src={`data:application/pdf;base64,${data}`}
            ></iframe>
          </div>
        </>
      )}
    </InfoModal>
  );
}
